import React, { useContext, useEffect } from "react";

import {
  Context,
  fetchTeachers,
  fetchTeacherSubjectsBySchool,
  SUBMIT_TEACHER_SUBJECTS_SUCCESS,
  SUBMIT_TEACHER_SUBJECTS_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { titles } from "../../../constants/titles";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import Toast from "../../../molecules/Toast";
import Subjects from "../../../templates/manager/Subjects";

const SubjectsPage = () => {
  const { state, dispatch } = useContext(Context);

  useEffect(() => {
    dispatch(fetchTeachers());
    dispatch(fetchTeacherSubjectsBySchool());
  }, [dispatch]);

  useEffect(() => {
    if (state.lastAction === SUBMIT_TEACHER_SUBJECTS_SUCCESS) {
      Toast.success(SUBMIT_TEACHER_SUBJECTS_SUCCESS_MESSAGE);
      dispatch(fetchTeacherSubjectsBySchool());
    }
  }, [state.lastAction, dispatch]);

  return (
    <div>
      <Breadcrumb currentTitle={titles.subjects} />
      <Subjects />
    </div>
  );
};

export default SubjectsPage;
